<div class="eg-chip-input" [class.disabled]="disabled" [class.error]="showError">
  <div class="eg-chip-input__wrapper" [class.has-chips]="emails.length > 0 || inputValue?.trim()?.length > 0">
    <div class="eg-chip-input__chips">
      @for (email of emails; let i = $index; track trackBy(i, email)) {
        <p-chip [label]="email" [removable]="!disabled" (onRemove)="!disabled && removeEmail(i)"> </p-chip>
      }

      <input
        class="eg-chip-input__input"
        [id]="id"
        [name]="name"
        [disabled]="disabled"
        [readonly]="readonly"
        [(ngModel)]="inputValue"
        (keydown)="onKeydown($event)"
        (blur)="onBlur()"
        [placeholder]="placeholder"
      />
    </div>

    <label [for]="id" class="eg-chip-input__label">
      {{ labelWithSuffix }}
    </label>
  </div>

  @if ((control?.touched && control?.errors && errorMessage) || showError) {
    <eg-form-error [errorMessage]="errorMessage" class="eg-chip-input__error"></eg-form-error>
  }
</div>
